import { render, staticRenderFns } from "./TaxIncentivesSummary.vue?vue&type=template&id=c3d660d6&scoped=true"
import script from "./TaxIncentivesSummary.vue?vue&type=script&lang=js"
export * from "./TaxIncentivesSummary.vue?vue&type=script&lang=js"
import style0 from "./TaxIncentivesSummary.vue?vue&type=style&index=0&id=c3d660d6&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c3d660d6",
  null
  
)

export default component.exports